<div style="position: relative;">
    <!-- LOADER -->
    <div *ngIf="pageLoading$ | async"
    style="
        position: absolute;
        z-index: 1000;
        height: 100%;
        width: 100%;">
        <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate" style="position: sticky; top: 50%; left: 50%;"></mat-progress-spinner>
    </div>
    <!-- LOADER -->
    <kt-portlet>
        <kt-portlet-body>

        <!-- Acción -->
        <div style="position: relative;">
            <div class="action-label">{{'TRACING_TASK_DETAIL.TASK_LABEL' | translate}}</div>

            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <span style="font-size: 1.3rem; font-weight: 500; margin-bottom: 20px;">{{ (taskDetail$ | async).taskDescription }}</span>

                    <div class="row justify-content-lg-start">
                        <!-- Porcentaje de avance -->
                        <div *ngIf="!subTaskId" class="row col-lg-6">
                            <label class="col-lg-4 col-form-label">
                                {{'TRACING_TASK_DETAIL.PROGRESS_PERCENT_LABEL' | translate}}
                            </label>
                            <div class="col-lg-6">
                                <kt-text-input
                                    [formGroup]="taskForm"
                                    controlName="progressPercent"
                                    [maxLength]="inputMaxLength">
                                </kt-text-input>
                            </div>
                        </div>
                        <!-- Estado de tarea iterativa -->
                        <div *ngIf="subTaskId" class="row col-lg-6">
                            <label class="col-lg-4 col-form-label">
                                {{'TRACING_TASK_DETAIL.COMPLETE_LABEL' | translate}}
                            </label>
                            <div class="col-lg-6" style="align-self: center;">
                                <mat-checkbox #completeCheck (change)="taskForm.get('progressPercent').patchValue( $event.checked? 100 : 0 )">
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                </kt-portlet-body>
            </kt-portlet>
        </div>

        

        <!-- Observaciones -->
        <div style="position: relative; margin-top: 2em;">
            <div class="action-label">{{'TRACING_TASK_DETAIL.OBSERVATIONS_LABEL' | translate}}</div>

            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <!-- Observación -->
                    <div class="row col-lg-12 justify-content-lg-between">
                        <div class="row col-lg-10">
                            <label class="col-lg-3 col-form-label">
                                {{'TRACING_TASK_DETAIL.OBSERVATION_LABEL' | translate}}
                            </label>
                            <div class="col-lg-9">
                                <kt-text-input
                                    [formGroup]="taskForm"
                                    controlName="observation"
                                    [maxLength]="inputMaxLength">
                                </kt-text-input>
                            </div>
                        </div>
                        <div class="col-lg-2" class="add-task-button">
                            <button *ngIf="!readOnly"
                                mat-raised-button color="primary"
                                [disabled]="!taskForm.get('observation').valid || taskForm.get('observation').pristine || !taskForm.get('observation').value"
                                (click)="addTaskObservation()">
                                <i class="material-icons md-48">add</i>
                                {{'TRACING_TASK_DETAIL.BUTTONS.ADD' | translate}}
                            </button>
                        </div>
                    </div>

                    <div class="mobile-table-container">
                        <!-- Table de comentarios -->
                    <mat-table #tableObservations [dataSource]="dataSourceObservations" class="mobile-table">
                        <!-- Fecha de Creación -->
                        <ng-container matColumnDef="createDate">
                            <mat-header-cell *matHeaderCellDef class="col-width-15">
                                {{'TRACING_TASK_DETAIL.OBSERVATION_TABLE.HEADER.CREATION_DATE' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="col-width-15">
                                {{(element.createDate | date: 'dd/MM/yyyy') || ('TRACING_TASK_DETAIL.NO_DATE' | translate) }}
                            </mat-cell>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="description">
                            <mat-header-cell *matHeaderCellDef class="col-width-75">
                                {{'TRACING_TASK_DETAIL.OBSERVATION_TABLE.HEADER.OBSERVATION' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="col-width-75">
                                {{ element.description }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef class="col-width-10">
                                {{'TRACING_TASK_DETAIL.OBSERVATION_TABLE.HEADER.ACTIONS' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="col-width-10">
                                <button *ngIf="!readOnly"
                                    [matTooltip]="'TRACING_TASK_DETAIL.OBSERVATION_TABLE.TOOLTIP.DELETE_OBSERVATION' | translate"
                                    mat-icon-button color="primary"
                                    class="medium"
                                    (click)="deleteTaskObservation(element)">
                                        <i class="material-icons">delete</i>
                                </button>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="noRecord">
                            <mat-footer-cell *matFooterCellDef>
                                <div style="width: 100%;text-align: center;">{{'TRACING_TASK_DETAIL.OBSERVATION_TABLE.EMPTY' | translate}}</div>
                            </mat-footer-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedObservationColumns;" style="padding: 0 1.5em 0 1.5em;"></mat-header-row>
                        <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedObservationColumns;" style="padding: 0 1.5em 0 1.5em;"></mat-row>

                        <mat-footer-row
                            *matFooterRowDef="['noRecord']"
                            [hidden]="dataSourceObservations.data.length > 0">
                        </mat-footer-row>
                    </mat-table>
                    </div>

                </kt-portlet-body>
            </kt-portlet>
        </div>

        <!-- Archivos -->
        <div style="position: relative; margin-top: 2em;">
            <div class="action-label">{{'TRACING_TASK_DETAIL.SUPPORT_DOCS' | translate}}</div>
            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <div class="file-buttons">
                        <button
                            *ngIf="!readOnly"
                            mat-raised-button color="primary"
                            (click)="fileInput.click()">
                            <div *ngIf="!spinnerDisplay" class="file-button">
                                <i class="material-icons md-48">add</i>
                                {{'TRACING_TASK_DETAIL.FILES.ADD_FILE_BUTTON' | translate}}
                            </div>
                            <div *ngIf="spinnerDisplay" class="file-button">
                                {{'FILEM.FILE_PROCESSING' | translate}}
                                {{filesProcessed}}
                                {{'FILEM.FILE_OUTOF' | translate}}
                                {{filesQueue}}
                                <mat-progress-spinner color="white" mode="indeterminate" diameter="15" class="mx-12"></mat-progress-spinner>
                            </div>
                        </button>
                    </div>

                    <input hidden type="file" multiple #fileInput (change)="onFileUpload($event.target.files)"/>

                    <div class="mobile-table-container">
                        <mat-table #tableCreate [dataSource]="dataSourceFilesCreate" class="mobile-table">
                            <!-- icon Column -->
                            <ng-container matColumnDef="icon">
                                <mat-header-cell *matHeaderCellDef class="col-width-8"></mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-8" style="text-align: center;">
                                    <mat-icon
                                        *ngIf="user.fullUserName === row.createUser || !row.createUser"
                                        [matTooltip]="'FILEM.TOOLTIP.FILE_OWNER' | translate"
                                        class="file-item">
                                            note_add
                                        </mat-icon>
                                    <mat-icon
                                        *ngIf="user.fullUserName !== row.createUser && row.createUser"
                                        [matTooltip]="'FILEM.TOOLTIP.FILE_NOT_OWNER' | translate"
                                        class="file-item">
                                            insert_drive_file
                                        </mat-icon>
                                </mat-cell>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef class="col-width-50">{{'FILEM.TABLE.NAME' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-50 download-item">
                                    <span class="cursor-pointer" (click)="getFileById(row)">{{ getFileName(row.fileName) }}</span>
                                </mat-cell>
                            </ng-container>

                            <!-- type Column -->
                            <ng-container matColumnDef="type">
                                <mat-header-cell *matHeaderCellDef class="col-width-15">{{'FILEM.TABLE.TYPE' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-15"> {{ getFileExtension(row.fileName) }}</mat-cell>
                            </ng-container>

                            <!-- Size Column -->
                            <ng-container matColumnDef="size">
                                <mat-header-cell *matHeaderCellDef class="col-width-15">{{'FILEM.TABLE.SIZE' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-15">{{row.fileSize === 0 ? '--': formatBytes(row.fileSize) }}</mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <mat-header-cell *matHeaderCellDef class="col-width-10">{{'FILEM.TABLE.ACTION' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-10">
                                    <button
                                        *ngIf="!readOnly && (user.fullUserName === row.createUser || !row.createUser)"
                                        mat-icon-button
                                        [matTooltip]="'FILEM.TOOLTIP.DELETE' | translate"
                                        matTooltipPosition="above"
                                        (click)="dropFile(row)">
                                        <mat-icon class="drop_row">
                                            close
                                        </mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="noRecord">
                                <mat-footer-cell *matFooterCellDef>
                                    <div style="width: 100%;text-align: center;">{{'FILEM.TABLE.EMPTY' | translate}}</div>
                                </mat-footer-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedFilesColumns;"></mat-header-row>
                            <mat-row class="mobile-table-row" *matRowDef="let row; columns: displayedFilesColumns;"></mat-row>

                            <mat-footer-row
                                *matFooterRowDef="['noRecord']"
                                [hidden]="dataSourceFilesCreate.data.length > 0">
                            </mat-footer-row>
                        </mat-table>
                    </div>

                </kt-portlet-body>
            </kt-portlet>
        </div>

        <!-- Add conversations for tracing tasks  -->
        <div style="position: relative; margin-top: 2em;" *ngIf="conversations?.formConversations != null">
            <div class="action-label">{{'TRACING_TASK_DETAIL.CONVERSATIONS.TITLE' | translate}}</div>
            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <div style="display: flex; justify-content:space-evenly">
                        <div style="font-size: 36px; text-align: center;">

                            <kt-conversation-manager
                                [matTooltip]="'EVALUATION.TOOLTIP.DISPLAY_CONVERSATION' | translate"
                                [icon]="'flaticon2-chat'"
                                [contextId]="0"
                                [conversationItems]="conversations.formConversations"
                                (message)="enqueueMessageItem($event)"
                                [conversationItemClass]="thirdpartyFollowUpFormConversationClass"
                                (messageDequeue)="dequeueMessageItem($event)">
                            </kt-conversation-manager>
                        </div>
                    </div>
                </kt-portlet-body>
            </kt-portlet>
        </div>

        <!--Files if task by File-->
        <div style="position: relative; margin-top: 2em;" *ngIf="taskType == 1">
            <div class="action-label">{{'TRACING_TASK_DETAIL.FILES.EXTRA_FILES' | translate}}</div>
            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <div style="display: flex; justify-content:space-evenly">
                        <div>
                            <p>{{'TRACING_TASK_DETAIL.FILES.TEMPLATES' | translate}}</p>
                            <div *ngIf="templates">
                                <div *ngFor="let template of templates">
                                    <div>{{template.fileName}}</div>
                                    <button mat-raised-button color="secondary" class="m-2"
                                    (click)="downloadTemplate(template)">{{'THIRDPARTY_TRACING_TASKS.BUTTONS.DOWNLOAD' | translate}}
                                    <mat-icon>file_download</mat-icon></button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p>{{'TRACING_TASK_DETAIL.FILES.USER_FILES' | translate}}</p>
                            <div *ngIf="userFiles">
                                <div *ngFor="let file of userFiles">
                                    <div>{{file.fileName}}</div>
                                    <button mat-raised-button color="primary" class="m-2"
                                    (click)="downloadUserFile(file)">{{'THIRDPARTY_TRACING_TASKS.BUTTONS.DOWNLOAD' | translate}}
                                    <mat-icon>file_download</mat-icon></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-portlet-body>
            </kt-portlet>
        </div>

        <!--Form-->
        <div style="position: relative; margin-top: 2em;" *ngIf="followupTaskForm?.followUpTaskFormItems?.length">
            <div class="action-label">{{'TRACING_TASK_DETAIL.FORM.FORM_RESULT' | translate}}</div>
            <kt-portlet class="kt-portlet--bordered">
                <kt-portlet-body>
                    <div style="color: var(--warning)">{{'ThirdPartyFollowUpTaskStatusEnum.'+ this.thirdpartyFollowupTaskState | translate }}</div>
                    <div *ngFor="let formItem of followupTaskForm.followUpTaskFormItems; index as i; count as count">
                        <kt-evaluation-form-item
                            [evaluationFormItem]="formItem"
                            [evaluationFormGroup]="evaluationForm"
                            [evaluationFormControlName]="''+formItem.id"
                            [answers]="formItem.followUpTaskFormItemAnswers"
                            [maxLength]="100"
                            [maxCommentLength]="256"
                            [exploreMode]="false"
                            [forceShowConversation]="thirdpartyFollowupTaskState != 0"
                            [formConversations]="conversations"
                            [conversationItemClass]="thirdpartyFollowUpConversationClass"
                            [conversationContextId]="thirdPartyFollowUpTaskFormItems[i].id"
                            (message)="enqueueMessageItem($event)"
                            (messageDequeue)="dequeueMessageItem($event)"
                            [initialFiles]="thirdPartyFollowUpTaskFormItems[i].fileDtos"
                            [fileDownloadFnc]="downloadAnswerFile(thirdPartyFollowUpTaskFormItems[i].id)"
                            [protectedMode]="true">
                        </kt-evaluation-form-item>
                    </div>
                </kt-portlet-body>
            </kt-portlet>
        </div>

        <!-- Buttons -->
        <div class="button-form-row" *ngIf="!readOnly">
            <button
                mat-raised-button color="primary"
                [disabled]="taskForm.invalid || (pageLoading$ | async)"
                (click)="saveTaskCompletionProcess()">
                    {{'TRACING_TASK_DETAIL.BUTTONS.SAVE' | translate}}
            </button>
            <button
                mat-raised-button color="primary"
                class="btn-return"
                (click)="cancelTaskCompletionProcess()">
                    {{'TRACING_TASK_DETAIL.BUTTONS.CANCEL' | translate}}
            </button>
        </div>

        </kt-portlet-body>
    </kt-portlet>
</div>


